import React from 'react'
import { EllipsisOutlined } from '@ant-design/icons'

import { LntDropdown, LntIconButton } from '@app/components/base'

import { BUTTON_TYPE, SIZE } from '@app/constants'

import type { DropdownMenuProps } from './types'

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ items, isDisabled }) => {
  return (
    <LntDropdown
      trigger={ ['click'] }
      items={ items }
      disabled={ isDisabled }
    >
      <LntIconButton
        type={ BUTTON_TYPE.text }
        size={ SIZE.middle }
        icon={ <EllipsisOutlined /> }
      />
    </LntDropdown>
  )
}
